export const asset = (path) => `/builtup/images/${path}`;
